<template>
  <!-- was <body> — nested body breaks the DOM (document already has one) -->
  <div data-sidebar="dark">
  <title>FLOCKR | Wallet</title>
  <div class="wlt-root" :style="themePageStyle">
    <div class="wlt-topbar">
      <div class="container d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-3">
          <back-button class="me-2" />
          <a href="javascript:void(0)" @click="$router.push('/')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:32px;" /></a>
          <span style="color:var(--fm-h,#F5F0E8);font-weight:600;">Wallet</span>
        </div>
        <div class="d-flex gap-2">
          <a href="javascript:void(0)" @click="$router.push('/escrow')" class="btn btn-sm btn-outline-secondary">Escrow</a>
          <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="btn btn-sm btn-outline-warning">Dashboard</a>
        </div>
      </div>
    </div>
    <div class="container wlt-container">
      <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>
      <template v-else>

        <!-- Balance Card -->
        <div class="wlt-balance-card">
          <div class="wlt-balance-label">Available Balance</div>
          <div class="wlt-balance-amount">KES {{ fN(wallet.available_balance) }}</div>
          <div v-if="inTransitTotal > 0" class="wlt-actual-line">
            Actual Balance: <strong>KES {{ fN(actualBalance) }}</strong>
            <span class="wlt-actual-hint">(KES {{ fN(inTransitTotal) }} being withdrawn)</span>
          </div>
          <div class="wlt-balance-row">
            <div><span class="wlt-balance-sub-label">Pending</span><span class="wlt-balance-sub-val">KES {{ fN(wallet.pending_balance) }}</span></div>
            <div><span class="wlt-balance-sub-label">Total Earned</span><span class="wlt-balance-sub-val" style="color:#50C878;">KES {{ fN(wallet.total_earned) }}</span></div>
            <div><span class="wlt-balance-sub-label">Withdrawn</span><span class="wlt-balance-sub-val">KES {{ fN(wallet.total_withdrawn) }}</span></div>
          </div>
          <button class="btn btn-warning text-dark fw-bold w-100 mt-3" @click="openWithdraw" :disabled="Number(wallet.available_balance) <= 0">
            <i class="mdi mdi-bank-transfer-out me-1"></i>Withdraw Funds
          </button>
          <div class="d-flex gap-2 mt-2">
            <button class="btn btn-sm btn-outline-warning flex-fill" @click="$router.push('/credit-passport')"><i class="mdi mdi-shield-star me-1"></i>Credit Passport</button>
            <button class="btn btn-sm btn-outline-secondary flex-fill" @click="$router.push('/credit-passport/statement')"><i class="mdi mdi-file-download me-1"></i>Download Statement</button>
          </div>
        </div>

        <!-- Withdraw Modal -->
        <div v-if="showWithdraw" class="wlt-overlay" @click.self="!wdSubmitting ? closeWithdraw() : null">
          <div class="wlt-modal">
            <!-- STEP 1: FORM -->
            <div v-if="wdStep === 1">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h6 style="color:var(--fm-h,#F5F0E8);font-weight:700;margin:0;"><i class="mdi mdi-bank-transfer-out me-2"></i>Withdraw</h6>
                <button class="btn btn-link text-muted p-0" @click="closeWithdraw()"><i class="mdi mdi-close" style="font-size:20px;"></i></button>
              </div>
              <div class="mb-2" style="color:var(--fm-s,#6B6356);font-size:12px;">Available: <strong style="color:#50C878;">KES {{ fN(wallet.available_balance) }}</strong></div>

              <div class="mb-3">
                <label class="wlt-label">Amount (KES)</label>
                <input v-model.number="wdAmount" type="number" class="wlt-input" placeholder="Enter amount" min="1" />
                <div v-if="Number(wallet.available_balance) > 0" style="margin-top:4px;"><button class="btn btn-sm" style="color:#BFA164;font-size:11px;padding:2px 8px;border:1px solid rgba(191,161,100,0.3);border-radius:4px;" @click="wdAmount = Number(wallet.available_balance)">Withdraw All</button></div>
              </div>

              <div class="mb-3">
                <label class="wlt-label">Withdraw To</label>
                <div class="d-flex gap-2">
                  <button class="wlt-method-btn" :class="{ active: wdMethod === 'mpesa' }" @click="wdMethod = 'mpesa'"><i class="mdi mdi-cellphone me-1"></i>M-Pesa</button>
                  <button class="wlt-method-btn" :class="{ active: wdMethod === 'bank' }" @click="wdMethod = 'bank'"><i class="mdi mdi-bank me-1"></i>Bank</button>
                </div>
              </div>

              <div v-if="wdMethod === 'mpesa'" class="mb-3">
                <label class="wlt-label">M-Pesa Phone Number</label>
                <div style="position:relative;"><span style="position:absolute;left:12px;top:50%;transform:translateY(-50%);color:var(--fm-s,#6B6356);font-size:13px;">+254</span><input v-model="wdPhone" type="tel" class="wlt-input" placeholder="7XX XXX XXX" style="padding-left:52px;" maxlength="10" /></div>
              </div>

              <div v-if="wdMethod === 'bank'">
                <div class="mb-3"><label class="wlt-label">Bank Name</label><input v-model="wdBankName" type="text" class="wlt-input" placeholder="e.g. Equity Bank" /></div>
                <div class="mb-3"><label class="wlt-label">Account Number</label><input v-model="wdBankAccount" type="text" class="wlt-input" placeholder="Account number" /></div>
              </div>

              <div v-if="wdError" style="color:#FF6B6B;font-size:12px;margin-bottom:10px;"><i class="mdi mdi-alert-circle me-1"></i>{{ wdError }}</div>

              <button class="btn btn-warning text-dark fw-bold w-100" @click="goToConfirm">Continue <i class="mdi mdi-arrow-right ms-1"></i></button>
            </div>

            <!-- STEP 2: CONFIRM -->
            <div v-if="wdStep === 2">
              <div class="text-center mb-3">
                <div style="width:48px;height:48px;border-radius:50%;background:rgba(191,161,100,0.12);display:flex;align-items:center;justify-content:center;margin:0 auto;"><i class="mdi mdi-bank-transfer-out" style="font-size:24px;color:#BFA164;"></i></div>
                <h6 style="color:var(--fm-h,#F5F0E8);font-weight:700;margin-top:10px;">Confirm Withdrawal</h6>
              </div>
              <div class="wlt-confirm-box">
                <div class="wlt-confirm-row"><span>Amount</span><strong style="color:var(--fm-h,#F5F0E8);font-size:18px;">KES {{ fN(wdAmount) }}</strong></div>
                <div class="wlt-confirm-row"><span>Method</span><strong style="color:var(--fm-h,#F5F0E8);">{{ wdMethod === 'mpesa' ? 'M-Pesa' : 'Bank Transfer' }}</strong></div>
                <div v-if="wdMethod === 'mpesa'" class="wlt-confirm-row"><span>Phone</span><strong style="color:var(--fm-h,#F5F0E8);">+254{{ wdPhone }}</strong></div>
                <div v-if="wdMethod === 'bank'" class="wlt-confirm-row"><span>Bank</span><strong style="color:var(--fm-h,#F5F0E8);">{{ wdBankName }}</strong></div>
                <div v-if="wdMethod === 'bank'" class="wlt-confirm-row"><span>Account</span><strong style="color:var(--fm-h,#F5F0E8);">{{ wdBankAccount }}</strong></div>
                <div class="wlt-confirm-row"><span>Balance after</span><strong style="color:#50C878;">KES {{ fN(Number(wallet.available_balance) - wdAmount) }}</strong></div>
              </div>
              <div v-if="wdError" style="color:#FF6B6B;font-size:12px;margin:10px 0;text-align:center;"><i class="mdi mdi-alert-circle me-1"></i>{{ wdError }}</div>
              <div class="d-flex gap-2 mt-3">
                <button class="btn btn-outline-secondary flex-fill" @click="wdStep = 1" :disabled="wdSubmitting">Back</button>
                <button class="btn btn-warning text-dark fw-bold flex-fill" @click="submitWithdrawal" :disabled="wdSubmitting">
                  <span v-if="wdSubmitting"><span class="spinner-border spinner-border-sm me-1"></span>Sending...</span>
                  <span v-else><i class="mdi mdi-check me-1"></i>Confirm Withdraw</span>
                </button>
              </div>
            </div>

            <!-- STEP 3: SUCCESS -->
            <div v-if="wdStep === 3" class="text-center">
              <div style="width:56px;height:56px;border-radius:50%;background:rgba(80,200,120,0.15);display:flex;align-items:center;justify-content:center;margin:0 auto;"><i class="mdi mdi-check-bold" style="font-size:28px;color:#50C878;"></i></div>
              <h5 style="color:#50C878;font-weight:700;margin-top:12px;">Withdrawal Requested!</h5>
              <p style="color:var(--fm-m,#A09888);font-size:13px;">Your withdrawal of <strong style="color:var(--fm-h,#F5F0E8);">KES {{ fN(wdCompletedAmount) }}</strong> has been submitted.</p>
              <div class="wlt-confirm-box mt-3">
                <div class="wlt-confirm-row"><span>Sent to</span><strong style="color:var(--fm-h,#F5F0E8);">{{ wdMethod === 'mpesa' ? '+254' + wdCompletedPhone : wdBankName }}</strong></div>
                <div class="wlt-confirm-row"><span>Status</span><strong style="color:#FFAB00;">Pending</strong></div>
                <div class="wlt-confirm-row"><span>New balance</span><strong style="color:#50C878;">KES {{ fN(wallet.available_balance) }}</strong></div>
              </div>
              <div style="background:rgba(191,161,100,0.06);border:1px solid rgba(191,161,100,0.15);border-radius:8px;padding:10px;margin-top:12px;font-size:11px;color:var(--fm-m,#A09888);">
                <i class="mdi mdi-information me-1" style="color:#BFA164;"></i>
                M-Pesa withdrawals are processed within minutes. Bank transfers may take 1-3 business days.
              </div>
              <button class="btn btn-success fw-bold w-100 mt-3" @click="closeWithdraw()"><i class="mdi mdi-check me-1"></i>Done</button>
            </div>
          </div>
        </div>

        <!-- Withdrawal Requests -->
        <div v-if="withdrawals.length > 0" class="wlt-section mt-4">
          <h6 style="color:var(--fm-h,#F5F0E8);font-size:14px;font-weight:700;margin-bottom:14px;"><i class="mdi mdi-bank-transfer-out me-2" style="color:#BFA164;"></i>Withdrawal Requests</h6>
          <div v-for="wd in withdrawals" :key="wd.id" class="wlt-wd-card">
            <div class="d-flex align-items-center gap-3">
              <div class="wlt-wd-icon" :class="'wlt-wd-' + wd.status">
                <i :class="wd.status === 'completed' ? 'mdi mdi-check' : wd.status === 'rejected' || wd.status === 'cancelled' ? 'mdi mdi-close' : wd.status === 'processing' ? 'mdi mdi-loading mdi-spin' : 'mdi mdi-clock-outline'"></i>
              </div>
              <div style="flex:1;min-width:0;">
                <div style="color:var(--fm-h,#F5F0E8);font-size:13px;font-weight:600;">KES {{ fN(wd.amount) }}</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ wd.withdrawal_method === 'mpesa' ? 'M-Pesa · +254' + (wd.mpesa_phone || '') : 'Bank · ' + (wd.bank_name || '') }} · {{ fmtDate(wd.created_at) }}</div>
                <div v-if="wd.rejection_reason" style="color:#FF6B6B;font-size:11px;margin-top:2px;">{{ wd.rejection_reason }}</div>
              </div>
              <div class="d-flex align-items-center gap-2">
                <button v-if="canEditWd(wd)" class="btn btn-sm wlt-wd-edit-btn" @click="openEditWd(wd)" title="Edit details"><i class="mdi mdi-pencil"></i></button>
                <button v-if="wd.status === 'pending'" class="btn btn-sm wlt-wd-cancel-btn" @click="confirmCancelWd(wd)" title="Cancel withdrawal"><i class="mdi mdi-close"></i></button>
                <div class="wlt-wd-badge" :class="'wlt-wd-badge-' + wd.status">{{ wdStatusLabel(wd.status) }}</div>
              </div>
            </div>
            <div v-if="canEditWd(wd)" style="font-size:10px;color:var(--fm-s,#6B6356);margin-top:6px;text-align:right;">
              <i class="mdi mdi-pencil me-1"></i>Editable for {{ editTimeLeft(wd) }}
            </div>
          </div>
        </div>

        <!-- Edit Withdrawal Modal -->
        <div v-if="showEditWd" class="wlt-overlay" @click.self="showEditWd = false">
          <div class="wlt-modal">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h6 style="color:var(--fm-h,#F5F0E8);font-weight:700;margin:0;"><i class="mdi mdi-pencil me-2" style="color:#BFA164;"></i>Edit Withdrawal Details</h6>
              <button class="btn btn-link text-muted p-0" @click="showEditWd = false"><i class="mdi mdi-close" style="font-size:20px;"></i></button>
            </div>
            <div style="color:var(--fm-s,#6B6356);font-size:12px;margin-bottom:12px;">Amount: <strong style="color:var(--fm-h,#F5F0E8);">KES {{ fN(editWd.amount) }}</strong></div>

            <div v-if="editWd.withdrawal_method === 'mpesa'" class="mb-3">
              <label class="wlt-label">M-Pesa Phone Number</label>
              <div style="position:relative;"><span style="position:absolute;left:12px;top:50%;transform:translateY(-50%);color:var(--fm-s,#6B6356);font-size:13px;">+254</span><input v-model="editWdPhone" type="tel" class="wlt-input" placeholder="7XX XXX XXX" style="padding-left:52px;" maxlength="10" /></div>
            </div>

            <div v-if="editWd.withdrawal_method === 'bank'">
              <div class="mb-3"><label class="wlt-label">Bank Name</label><input v-model="editWdBankName" type="text" class="wlt-input" /></div>
              <div class="mb-3"><label class="wlt-label">Account Number</label><input v-model="editWdBankAccount" type="text" class="wlt-input" /></div>
            </div>

            <div v-if="editWdError" style="color:#FF6B6B;font-size:12px;margin-bottom:10px;"><i class="mdi mdi-alert-circle me-1"></i>{{ editWdError }}</div>
            <div v-if="editWdSuccess" style="color:#50C878;font-size:12px;margin-bottom:10px;"><i class="mdi mdi-check-circle me-1"></i>{{ editWdSuccess }}</div>

            <div class="d-flex gap-2">
              <button class="btn btn-outline-secondary flex-fill" @click="showEditWd = false">Cancel</button>
              <button class="btn btn-warning text-dark fw-bold flex-fill" @click="saveEditWd" :disabled="editWdSaving">
                <span v-if="editWdSaving"><span class="spinner-border spinner-border-sm me-1"></span></span>
                <span v-else><i class="mdi mdi-check me-1"></i>Update Details</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Cancel Withdrawal Confirmation -->
        <div v-if="showCancelWd" class="wlt-overlay" @click.self="showCancelWd = false">
          <div class="wlt-modal" style="max-width:380px;">
            <div class="text-center mb-3">
              <div style="width:48px;height:48px;border-radius:50%;background:rgba(255,107,107,0.12);display:flex;align-items:center;justify-content:center;margin:0 auto 12px;">
                <i class="mdi mdi-alert-circle" style="font-size:24px;color:#FF6B6B;"></i>
              </div>
              <h6 style="color:var(--fm-h,#F5F0E8);font-weight:700;margin:0;">Cancel Withdrawal?</h6>
            </div>
            <div style="background:var(--fm-bg2,#0F0F0F);border-radius:8px;padding:12px;margin-bottom:16px;">
              <div class="d-flex justify-content-between mb-1"><span style="color:var(--fm-s,#6B6356);font-size:12px;">Amount</span><span style="color:var(--fm-h,#F5F0E8);font-size:14px;font-weight:700;">KES {{ fN(cancelWd.amount) }}</span></div>
              <div class="d-flex justify-content-between"><span style="color:var(--fm-s,#6B6356);font-size:12px;">To</span><span style="color:var(--fm-m,#A09888);font-size:12px;">{{ cancelWd.withdrawal_method === 'mpesa' ? '+254' + (cancelWd.mpesa_phone || '') : (cancelWd.bank_name || 'Bank') }}</span></div>
            </div>
            <p style="color:var(--fm-m,#A09888);font-size:12px;text-align:center;margin-bottom:16px;">KES {{ fN(cancelWd.amount) }} will be restored to your wallet balance.</p>
            <div v-if="cancelWdError" style="color:#FF6B6B;font-size:12px;margin-bottom:10px;text-align:center;"><i class="mdi mdi-alert-circle me-1"></i>{{ cancelWdError }}</div>
            <div class="d-flex gap-2">
              <button class="btn btn-outline-secondary flex-fill" @click="showCancelWd = false">Keep It</button>
              <button class="btn btn-danger fw-bold flex-fill" @click="doCancelWd" :disabled="cancelWdLoading">
                <span v-if="cancelWdLoading"><span class="spinner-border spinner-border-sm me-1"></span></span>
                <span v-else><i class="mdi mdi-close me-1"></i>Cancel Withdrawal</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Transactions -->
        <div class="wlt-section mt-4">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h6 style="color:var(--fm-h,#F5F0E8);font-size:14px;font-weight:700;margin:0;"><i class="mdi mdi-swap-horizontal me-2"></i>Transactions</h6>
            <div class="wlt-filter-tabs">
              <button :class="{ active: txFilter === 'all' }" @click="txFilter = 'all'">All</button>
              <button :class="{ active: txFilter === 'credit' }" @click="txFilter = 'credit'">Credits</button>
              <button :class="{ active: txFilter === 'debit' }" @click="txFilter = 'debit'">Debits</button>
            </div>
          </div>

          <div v-if="filteredTx.length === 0" class="text-center py-4">
            <i class="mdi mdi-swap-horizontal" style="font-size:36px;color:var(--fm-s,#2A2520);"></i>
            <p style="color:var(--fm-s,#6B6356);font-size:13px;margin-top:8px;">No transactions yet</p>
          </div>

          <div v-else>
            <div v-for="tx in filteredTx" :key="tx.id" class="wlt-tx-card">
              <div class="d-flex align-items-center gap-3">
                <div class="wlt-tx-icon" :class="tx.type === 'credit' ? 'credit' : 'debit'">
                  <i :class="tx.type === 'credit' ? 'mdi mdi-arrow-down' : 'mdi mdi-arrow-up'"></i>
                </div>
                <div class="flex-fill">
                  <div class="wlt-tx-desc">{{ tx.description || txLabel(tx) }}</div>
                  <div class="wlt-tx-meta">{{ tx.category }} &middot; {{ fmtD(tx.created_at) }}</div>
                </div>
                <div class="wlt-tx-amount" :class="tx.type">
                  {{ tx.type === 'credit' ? '+' : '-' }}KES {{ fN(tx.amount) }}
                </div>
              </div>
            </div>

            <button v-if="hasMore" class="btn btn-outline-secondary btn-sm w-100 mt-3" @click="loadMore" :disabled="loadingMore">
              <span v-if="loadingMore"><span class="spinner-border spinner-border-sm me-1"></span></span>
              Load More
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
html[data-theme="light"] .wlt-balance-card{background:linear-gradient(135deg,#FBF5E9 0%,#FFFFFF 100%)!important}
</style>
<style scoped>
.wlt-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh;color:var(--fm-h,#F5F0E8)}
.wlt-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.wlt-container{padding-top:80px;padding-bottom:60px;max-width:600px}

.wlt-balance-card{background:linear-gradient(135deg,#1A1708 0%,#141414 100%);border:1px solid var(--fm-br,#2A2520);border-radius:16px;padding:28px;text-align:center}
.wlt-balance-label{font-size:12px;color:var(--fm-s,#6B6356);text-transform:uppercase;letter-spacing:1px;margin-bottom:4px}
.wlt-balance-amount{font-size:36px;font-weight:800;color:#BFA164;margin-bottom:16px}
.wlt-actual-line{font-size:13px;color:var(--fm-m,#A09888);margin:-8px 0 14px}
.wlt-actual-line strong{color:#50C878}
.wlt-actual-hint{font-size:11px;color:var(--fm-s,#6B6356);margin-left:4px}
.wlt-balance-row{display:flex;justify-content:space-around;padding:14px 0;border-top:1px solid var(--fm-br,#1E1E1E);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.wlt-balance-sub-label{display:block;font-size:10px;color:var(--fm-s,#6B6356);margin-bottom:2px}
.wlt-balance-sub-val{font-size:13px;font-weight:600;color:var(--fm-m,#A09888)}

.wlt-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.7);z-index:200;display:flex;align-items:center;justify-content:center;padding:20px}
.wlt-modal{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#2A2520);border-radius:16px;padding:24px;width:100%;max-width:420px}
.wlt-label{display:block;color:var(--fm-m,#A09888);font-size:12px;font-weight:500;margin-bottom:6px}
.wlt-input{width:100%;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:10px 14px;color:var(--fm-h,#F5F0E8);font-size:14px}
.wlt-input:focus{border-color:#BFA164;outline:none}
.wlt-input::placeholder{color:#4A4540}
.wlt-method-btn{flex:1;padding:10px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;color:var(--fm-m,#A09888);font-size:13px;font-weight:600;cursor:pointer;transition:all .2s}
.wlt-method-btn.active{background:rgba(191,161,100,0.1);border-color:#BFA164;color:#BFA164}

.wlt-section{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:20px}
.wlt-filter-tabs{display:flex;gap:4px}
.wlt-filter-tabs button{padding:4px 12px;border-radius:12px;border:1px solid var(--fm-br,#2A2520);background:var(--fm-bg2,#0F0F0F);color:var(--fm-s,#6B6356);font-size:11px;cursor:pointer;transition:all .2s}
.wlt-filter-tabs button.active{background:rgba(191,161,100,0.1);border-color:#BFA164;color:#BFA164}

.wlt-tx-card{padding:12px 0;border-bottom:1px solid var(--fm-br,#1E1E1E)}
.wlt-tx-card:last-child{border-bottom:none}
.wlt-tx-icon{width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0}
.wlt-tx-icon.credit{background:rgba(80,200,120,0.1);color:#50C878}
.wlt-tx-icon.debit{background:rgba(255,107,107,0.1);color:#FF6B6B}
.wlt-tx-desc{font-size:13px;font-weight:600;color:var(--fm-h,#F5F0E8)}
.wlt-tx-meta{font-size:11px;color:var(--fm-s,#6B6356);margin-top:1px}
.wlt-tx-amount{font-size:14px;font-weight:700;white-space:nowrap}
.wlt-tx-amount.credit{color:#50C878}
.wlt-tx-amount.debit{color:#FF6B6B}
.wlt-confirm-box{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:12px;display:flex;flex-direction:column;gap:8px}
.wlt-confirm-row{display:flex;justify-content:space-between;align-items:center;font-size:13px;color:var(--fm-s,#6B6356)}
.wlt-wd-card{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:12px 14px;margin-bottom:8px}
.wlt-wd-edit-btn{background:rgba(191,161,100,0.1);border:1px solid rgba(191,161,100,0.25);color:#BFA164;width:28px;height:28px;padding:0;display:flex;align-items:center;justify-content:center;border-radius:6px;font-size:13px}
.wlt-wd-edit-btn:hover{background:rgba(191,161,100,0.2);color:#BFA164}
.wlt-wd-cancel-btn{background:rgba(255,107,107,0.08);border:1px solid rgba(255,107,107,0.2);color:#FF6B6B;width:28px;height:28px;padding:0;display:flex;align-items:center;justify-content:center;border-radius:6px;font-size:13px}
.wlt-wd-cancel-btn:hover{background:rgba(255,107,107,0.18);color:#FF6B6B}
.wlt-wd-icon{width:32px;height:32px;min-width:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:14px}
.wlt-wd-pending{background:rgba(255,171,0,0.1);color:#FFAB00}
.wlt-wd-approved{background:rgba(80,200,120,0.1);color:#50C878}
.wlt-wd-processing{background:rgba(191,161,100,0.1);color:#BFA164}
.wlt-wd-completed{background:rgba(80,200,120,0.15);color:#50C878}
.wlt-wd-rejected{background:rgba(255,107,107,0.1);color:#FF6B6B}
.wlt-wd-cancelled{background:rgba(107,99,86,0.15);color:var(--fm-s,#6B6356)}
.wlt-wd-badge{font-size:10px;font-weight:700;padding:3px 8px;border-radius:4px;text-transform:uppercase;letter-spacing:0.5px;white-space:nowrap}
.wlt-wd-badge-pending{background:rgba(255,171,0,0.1);color:#FFAB00;border:1px solid rgba(255,171,0,0.2)}
.wlt-wd-badge-approved{background:rgba(80,200,120,0.1);color:#50C878;border:1px solid rgba(80,200,120,0.2)}
.wlt-wd-badge-processing{background:rgba(191,161,100,0.1);color:#BFA164;border:1px solid rgba(191,161,100,0.2)}
.wlt-wd-badge-completed{background:rgba(80,200,120,0.1);color:#50C878;border:1px solid rgba(80,200,120,0.2)}
.wlt-wd-badge-rejected{background:rgba(255,107,107,0.1);color:#FF6B6B;border:1px solid rgba(255,107,107,0.2)}
.wlt-wd-badge-cancelled{background:rgba(107,99,86,0.1);color:var(--fm-s,#6B6356);border:1px solid rgba(107,99,86,0.2)}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .wlt-container { padding-top: 70px; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)); padding-left: 12px; padding-right: 12px; }
  .wlt-balance-card { padding: 18px; border-radius: 12px; }
  .wlt-balance-amount { font-size: 28px; margin-bottom: 12px; }
  .wlt-balance-row { padding: 10px 0; }
  .wlt-balance-sub-val { font-size: 12px; }
  .wlt-overlay { padding: 12px; align-items: flex-end; }
  .wlt-overlay > div { max-height: 88vh; overflow-y: auto; border-radius: 14px 14px 0 0; }
  .wlt-wd-badge { font-size: 9px; padding: 2px 6px; }
}
</style>
<script>
import { execute, flocker } from "@/api";
export default {
  name: "WalletPage",
  data() {
    return {
      darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',

      loading: true, wallet: {},
      withdrawals: [],
      transactions: [], txPage: 1, hasMore: true, loadingMore: false, txFilter: 'all',
      showWithdraw: false, wdStep: 1, wdAmount: null, wdMethod: 'mpesa', wdPhone: '', wdBankName: '', wdBankAccount: '',
      wdSubmitting: false, wdError: '', wdSuccess: '', wdCompletedAmount: 0, wdCompletedPhone: '',
      showEditWd: false, editWd: {}, editWdPhone: '', editWdBankName: '', editWdBankAccount: '', editWdError: '', editWdSuccess: '', editWdSaving: false,
      showCancelWd: false, cancelWd: {}, cancelWdError: '', cancelWdLoading: false
    };
  },
  computed: {
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},

    inTransitTotal() {
      return this.withdrawals
        .filter(function(w) { return ['pending','approved','processing'].indexOf(w.status) !== -1; })
        .reduce(function(s, w) { return s + Number(w.amount || 0); }, 0);
    },
    actualBalance() { return Number(this.wallet.available_balance || 0) + this.inTransitTotal; },
    filteredTx() {
      if (this.txFilter === 'all') return this.transactions;
      var f = this.txFilter;
      return this.transactions.filter(function(t) { return t.type === f; });
    }
  },
  mounted() {
    // Apply global theme
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);
    this.loadWallet(); },
  methods: {
    fN(v) { var n = Number(v || 0); return n.toLocaleString('en-KE', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); },
    fmtD(d) { return d ? new Date(d).toLocaleDateString('en-KE', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : ''; },
    txLabel(tx) {
      var m = { sale: 'Sale Payment', withdrawal: 'Withdrawal', refund: 'Refund', platform_fee: 'Platform Fee', topup: 'Top Up' };
      return m[tx.category] || tx.category || 'Transaction';
    },
    async loadWallet() {
      this.loading = true;
      var userId = sessionStorage.getItem('userId');
      if (!userId) { this.$router.push('/login'); return; }
      try {
        var f = new FormData();
        f.append('function', 'getWalletBalance');
        f.append('userId', userId);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) this.wallet = r.data.data.wallet || {};
        await this.loadTransactions();
        await this.loadWithdrawals();
      } catch (e) { console.error(e); }
      this.loading = false;
    },
    async loadWithdrawals() {
      var userId = sessionStorage.getItem('userId');
      try {
        var f = new FormData();
        f.append('function', 'getWithdrawals');
        f.append('userId', userId);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) this.withdrawals = (r.data.data && r.data.data.withdrawals) || r.data.data || [];
      } catch (e) { this.withdrawals = []; }
    },
    wdStatusLabel(s) {
      var m = { pending: 'Pending', approved: 'Approved', processing: 'Processing', completed: 'Sent', rejected: 'Rejected', cancelled: 'Cancelled' };
      return m[s] || s;
    },
    fmtDate(d) { if (!d) return ''; var dt = new Date(d); return dt.toLocaleDateString('en-KE', { day: 'numeric', month: 'short' }) + ', ' + dt.toLocaleTimeString('en-KE', { hour: '2-digit', minute: '2-digit' }); },

    // Edit withdrawal (pending only, within 15 minutes)
    canEditWd(wd) {
      if (wd.status !== 'pending') return false;
      var created = new Date(wd.created_at).getTime();
      var now = Date.now();
      var fifteenMin = 15 * 60 * 1000;
      return (now - created) < fifteenMin;
    },
    editTimeLeft(wd) {
      var created = new Date(wd.created_at).getTime();
      var remaining = Math.max(0, Math.floor((15 * 60 * 1000 - (Date.now() - created)) / 1000));
      var min = Math.floor(remaining / 60);
      var sec = remaining % 60;
      return min + ':' + (sec < 10 ? '0' : '') + sec;
    },
    openEditWd(wd) {
      this.editWd = wd;
      this.editWdPhone = wd.mpesa_phone || '';
      this.editWdBankName = wd.bank_name || '';
      this.editWdBankAccount = wd.bank_account || '';
      this.editWdError = ''; this.editWdSuccess = '';
      this.showEditWd = true;
    },
    async saveEditWd() {
      this.editWdError = ''; this.editWdSuccess = '';
      if (this.editWd.withdrawal_method === 'mpesa' && (!this.editWdPhone || this.editWdPhone.length < 9)) {
        this.editWdError = 'Enter a valid phone number.'; return;
      }
      if (this.editWd.withdrawal_method === 'bank' && (!this.editWdBankName || !this.editWdBankAccount)) {
        this.editWdError = 'Enter bank details.'; return;
      }
      if (!this.canEditWd(this.editWd)) {
        this.editWdError = 'Edit window has expired (15 minutes).'; return;
      }
      this.editWdSaving = true;
      try {
        var f = new FormData();
        f.append('function', 'updateWithdrawalDetails');
        f.append('withdrawalId', this.editWd.id);
        f.append('userId', sessionStorage.getItem('userId'));
        if (this.editWd.withdrawal_method === 'mpesa') f.append('phone', this.editWdPhone);
        else { f.append('bankName', this.editWdBankName); f.append('bankAccount', this.editWdBankAccount); }
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          this.editWdSuccess = 'Details updated!';
          await this.loadWithdrawals();
          var self = this;
          setTimeout(function() { self.showEditWd = false; }, 1200);
        } else {
          this.editWdError = (r.data && r.data.message) || 'Update failed.';
        }
      } catch (e) { this.editWdError = 'Something went wrong.'; }
      this.editWdSaving = false;
    },
    confirmCancelWd(wd) {
      this.cancelWd = wd;
      this.cancelWdError = '';
      this.cancelWdLoading = false;
      this.showCancelWd = true;
    },
    async doCancelWd() {
      this.cancelWdError = '';
      this.cancelWdLoading = true;
      try {
        var f = new FormData();
        f.append('function', 'cancelWithdrawal');
        f.append('withdrawalId', this.cancelWd.id);
        f.append('userId', sessionStorage.getItem('userId'));
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          this.showCancelWd = false;
          await this.loadWallet();
        } else {
          this.cancelWdError = (r.data && r.data.message) || 'Cancel failed.';
        }
      } catch (e) { this.cancelWdError = 'Something went wrong.'; }
      this.cancelWdLoading = false;
    },
    async loadTransactions() {
      var userId = sessionStorage.getItem('userId');
      try {
        var f = new FormData();
        f.append('function', 'getWalletTransactions');
        f.append('userId', userId);
        f.append('page', this.txPage);
        f.append('limit', 20);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          var txs = r.data.data.transactions || [];
          if (this.txPage === 1) this.transactions = txs;
          else this.transactions = this.transactions.concat(txs);
          this.hasMore = txs.length >= 20;
        }
      } catch (e) { console.error(e); }
    },
    async loadMore() {
      this.loadingMore = true;
      this.txPage++;
      await this.loadTransactions();
      this.loadingMore = false;
    },
    openWithdraw() {
      this.wdStep = 1; this.wdError = ''; this.wdSuccess = '';
      this.wdAmount = null; this.wdMethod = 'mpesa';
      var ph = sessionStorage.getItem('userPhone') || '';
      this.wdPhone = ph.replace('+254','').replace('254','');
      this.showWithdraw = true;
    },
    closeWithdraw() {
      this.showWithdraw = false; this.wdStep = 1; this.wdError = '';
      this.loadWallet();
    },
    goToConfirm() {
      this.wdError = '';
      if (!this.wdAmount || this.wdAmount <= 0) { this.wdError = 'Enter a valid amount.'; return; }
      if (this.wdAmount > Number(this.wallet.available_balance)) { this.wdError = 'Insufficient balance.'; return; }
      if (this.wdMethod === 'mpesa' && (!this.wdPhone || this.wdPhone.length < 9)) { this.wdError = 'Enter a valid M-Pesa phone number.'; return; }
      if (this.wdMethod === 'bank' && (!this.wdBankName || !this.wdBankAccount)) { this.wdError = 'Enter bank details.'; return; }
      this.wdStep = 2;
    },
    async submitWithdrawal() {
      this.wdError = '';
      this.wdSubmitting = true;
      var userId = sessionStorage.getItem('userId');
      try {
        var f = new FormData();
        f.append('function', 'requestWithdrawal');
        f.append('userId', userId);
        f.append('amount', this.wdAmount);
        f.append('method', this.wdMethod);
        if (this.wdMethod === 'mpesa') f.append('phone', this.wdPhone);
        else { f.append('bankName', this.wdBankName); f.append('bankAccount', this.wdBankAccount); }
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          this.wdCompletedAmount = this.wdAmount;
          this.wdCompletedPhone = this.wdPhone;
          this.wallet.available_balance = Number(this.wallet.available_balance) - this.wdAmount;
          this.wdStep = 3;
        } else {
          this.wdError = (r.data && r.data.message) || 'Withdrawal failed.';
        }
      } catch (e) { this.wdError = 'Something went wrong.'; }
      this.wdSubmitting = false;
    }
  }
};
</script>